import { styled } from '@mui/material/styles';

export const PDFRoot = styled('div', { label: 'PDFRoot' })(() => ({
  position: 'relative',
  width: '100%',
  height: '100%',

  '& .react-pdf__Document': {
    overflow: 'auto',
    maxHeight: '100%',
    height: '100%',
    position: 'relative',

    // react-pdf lib classes
    '& .react-pdf__Page': {
      borderRadius: 2,
      position: 'relative',
      height: '100%',

      '& > .react-pdf__Page__textContent, & > .react-pdf__Page__canvas': {
        borderRadius: 2,
      },

      '& .react-pdf__Page__annotations': {
        display: 'none',
      },
    },
  },
}));

export const PDFPages = styled('div', { label: 'PDFPages' })(() => ({
  display: 'block',
  width: '100%',
  position: 'relative',
  height: '100%',
}));

export const PDFPage = styled('div', { label: 'PDFPage' })(({ theme }) => ({
  display: 'block',

  margin: theme.spacing(1.5, 'auto'),
  minWidth: '100px',
  position: 'relative',

  '&:last-child': {
    marginBottom: 80,
  },
}));
